import { keys } from '@/config/constants'
import dialog from '@/views/v-dialogs/changelog'
import page from '@/views/v-page/changelog'
import upload from '@/views/v-uploader/changelog'
import region from '@/views/v-region/changelog'
import selectpage from '@/views/v-selectpage/changelog'
import suggest from '@/views/v-suggest/changelog'
import playback from '@/views/v-playback/changelog'
import selectmenu from '@/views/v-selectmenu/changelog'
import gallery from '@/views/v-gallery/changelog'

export default {
  [keys.Dialogs]: dialog,
  [keys.Page]: page,
  [keys.Uploader]: upload,
  [keys.Region]: region,
  [keys.SelectPage]: selectpage,
  [keys.Suggest]: suggest,
  [keys.PlayBack]: playback,
  [keys.SelectMenu]: selectmenu,
  [keys.Gallery]: gallery
}
